import * as React from "react";

function SvgTextIcon(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}><path d="M17.1 1.1H7.4C4.4 1.1 2 3.5 2 6.5c0 3 2.4 5.4 5.4 5.4.4 0 .7 0 .9-.1v6.3c0 .5.5.8.9.8s.9-.3.9-.8V2.7h2.4v15.4c0 .5.5.8.9.8s.9-.3.9-.8V2.7h2.6c.5 0 .8-.4.8-.8.2-.4-.1-.8-.6-.8zM8.4 10c-.2.1-.5.2-.9.2-2.1 0-3.8-1.7-3.8-3.8s1.7-3.8 3.8-3.8c.4 0 .7.1.9.2V10z" /></svg>;
}

export default SvgTextIcon;